import { useState, useEffect, useRef } from "react";
import styles from "./styles.module.css";
import CloseIcon from "images/svg/Close.svg";

export default function StaffAccessCodeDialog({ open, onClose, onSuccess, requiredCode, title = "Access Required" }) {
  const [authCode, setAuthCode] = useState("");
  const [authError, setAuthError] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) {
      setAuthCode("");
      setAuthError("");
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 100);
    }
  }, [open]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value && value.length > 4) return;

    setAuthCode(value);
    if (authError) setAuthError("");

    if (value && value.length === 4) {
      if (value === requiredCode) {
        setAuthCode("");
        setAuthError("");
        onSuccess();
      } else {
        setAuthError("Invalid access code");
        setAuthCode("");
      }
    }
  };

  if (!open) return null;

  return (
    <div className={styles.popUp} onClick={onClose}>
      <div className={styles.contentWrapper} onClick={(e) => e.stopPropagation()}>
        <div className={styles.headInfoSec}>
          <h2>{title}</h2>
          <img src={CloseIcon} alt="Close" onClick={onClose} className={styles.icon} />
        </div>
        <div className={styles.contentArea}>
          <h3 className={styles.subTitle}>Please enter the 4-digit access code to continue.</h3>
          <div className={styles.inputContainer}>
            <input
              ref={inputRef}
              type="password"
              placeholder="Enter 4-digit code"
              className={`${styles.amountInput} ${authError ? styles.errorInput : ""}`}
              value={authCode}
              onChange={handleInputChange}
            />
            {authError && <div className={styles.errorText}>{authError}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
